import React, { useState, useEffect } from 'react';
import { useNavigate, Navigate ,Link} from 'react-router-dom';
import { login } from '../../api/auth';
import axios from 'axios';

const LoginForm = () => {
  const [userID, setUserID] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [forgotUserID, setForgotUserID] = useState('');
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotLoading, setForgotLoading] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  // Handle modal fade animation
  useEffect(() => {
    if (showForgotModal) {
      setModalVisible(true);
    } else {
      setModalVisible(false);
    }
  }, [showForgotModal]);

  const handleCloseModal = () => {
    setModalVisible(false);
    setTimeout(() => {
      setShowForgotModal(false);
    }, 300); // Match the CSS transition duration
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await login(userID, password);
      localStorage.setItem('token', response.token);
      localStorage.setItem('role', response.role);
      
      if (response.role === 'admin') {
        // console.log("admin=====================");
        navigate('/admin');
        // <Navigate to="/admin" />
      } else {
        // console.log("user=====================");
        navigate('/user');
        // console.log("whydddddd");
      }
    } catch (error) {
      setError(error.response?.data?.message || 'ログインに失敗しました。');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <div style={{ textAlign: 'center', padding: '10px' }}>
      <h2>ログイン</h2>
      <form onSubmit={handleSubmit} style={{ marginTop: '55px' }}>
        <div style={{ marginBottom: '15px' , display:'flex', alignItems:'center'}}>
          <label style={{ marginLeft: '15px' }}>
            User ID:
          </label>
          <input
            type="text"
            value={userID}
            onChange={(e) => setUserID(e.target.value)}
            required
            style={{
              marginLeft:'10px',
              width: '60%',
              padding: '10px',
              fontSize: '16px',
              border: '1px solid #ccc',
              borderRadius: '5px'

            }}
          />
        </div>
        <div style={{ marginBottom: '15px' ,display:'flex', alignItems:'center'}}>
          <label style={{ marginLeft: '15px' }}>
            PASS:
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{
              marginLeft:'25px',
              width: '60%',
              padding: '10px',
              fontSize: '16px',
              border: '1px solid #ccc',
              borderRadius: '5px'
            }}
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          style={{
            marginTop:'20px',
            backgroundColor: '#ff6b35',
            color: 'white',
            border: 'none',
            padding: '15px 50px',
            fontSize: '16px',
            borderRadius: '5px',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.7 : 1
          }}
        >
          {loading ? 'ログイン中...' : 'ログイン'}
        </button>
      </form>
      {error && (
        <p style={{ marginTop: '15px', color: 'red' }}>
          {error}
        </p>
      )}
      <p style={{ marginTop: '25px' }}>
        <a href="#" onClick={(e) => { e.preventDefault(); setShowForgotModal(true); }} style={{ color: '#666', textDecoration: 'none' }}>
          パスワード忘れた方はこちら
        </a>
      </p>
      <p style={{ marginTop: '-10px', fontSize: '12px', color: '#666' }}>
        ※18歳未満禁止「高校生の利用不可」
      </p>
    </div>
    {showForgotModal && (
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
        alignItems: 'center', justifyContent: 'center', zIndex: 1000,
        opacity: modalVisible ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out'
      }}>
        <div style={{ 
          background: 'white', 
          padding: '20px', 
          borderRadius: '8px', 
          width: '400px', 
          maxWidth: '90%',
          transform: modalVisible ? 'scale(1)' : 'scale(0.8)',
          transition: 'transform 0.3s ease-in-out'
        }}>
          <h3 style={{ marginTop: 0, marginBottom: '15px' }}>パスワード再発行</h3>
          <div style={{ marginBottom: '10px' }}>
            <label>ユーザーID</label>
            <input
              type="text"
              value={forgotUserID}
              onChange={(e) => setForgotUserID(e.target.value)}
              style={{ width: '90%', padding: '10px', border: '1px solid #ccc', borderRadius: '5px' }}
            />
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label>メールアドレス</label>
            <input
              type="email"
              value={forgotEmail}
              onChange={(e) => setForgotEmail(e.target.value)}
              style={{ width: '90%', padding: '10px', border: '1px solid #ccc', borderRadius: '5px' }}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
            <button
              onClick={handleCloseModal}
              style={{ backgroundColor: '#95a5a6', color: '#fff', border: 'none', padding: '8px 14px', borderRadius: '5px', cursor: 'pointer' }}
            >キャンセル</button>
            <button
              onClick={async () => {
                if (!forgotUserID.trim() || !forgotEmail.trim()) return;
                setForgotLoading(true);
                try {
                  const res = await axios.post(`${API_URL}/api/auth/forgot`, { userID: forgotUserID.trim(), email: forgotEmail.trim() });
                  alert('新しいパスワードをメールで送信しました。');
                  handleCloseModal();
                  setForgotUserID('');
                  setForgotEmail('');
                } catch (err) {
                  const msg = err?.response?.data?.message || 'エラーが発生しました';
                  alert(msg);
                } finally {
                  setForgotLoading(false);
                }
              }}
              disabled={forgotLoading || !forgotUserID.trim() || !forgotEmail.trim()}
              style={{ backgroundColor: '#ff6b35', color: '#fff', border: 'none', padding: '8px 14px', borderRadius: '5px', cursor: forgotLoading ? 'not-allowed' : 'pointer' }}
            >{forgotLoading ? '送信中...' : '確認'}</button>
          </div>
        </div>
      </div>
    )}
    </>
  );
};

export default LoginForm; 